module.exports = __webpack_public_path__ + "img/image37.42f0a708.png";